var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckboxSelected = function SvgCheckboxSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "checkbox-selected_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M895.872 0A128.064 128.064 0 0 1 1024 128.128v767.744A128.064 128.064 0 0 1 895.872 1024H128.128A128.064 128.064 0 0 1 0 895.872V128.128A128.064 128.064 0 0 1 128.128 0h767.744zM757.44 320h-61.568c-13.504 0-26.112 6.528-33.984 17.408L455.52 622.592l-93.44-129.248a41.856 41.856 0 0 0-34.016-17.408h-61.536a10.496 10.496 0 0 0-8.544 16.64l163.712 226.048c16.64 23.168 51.2 23.168 67.84 0l276.48-382.016A10.496 10.496 0 0 0 757.44 320z",
    fill: "var(--primaryColor)"
  })));
};

export default SvgCheckboxSelected;